module.exports = __webpack_public_path__ + "img/nolist.c03c199a.png";